module.exports = __webpack_public_path__ + "img/Ankle_NORE.f777c99d.jpg";